var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"bg-black/75 w-60 text-white flex items-center cursor-pointer",class:_vm.is_active ? 'bg-[#4cae4c]' : ''},_vm.handlers),[_c('div',{staticClass:"px-3"},[_c('i',{staticClass:"icon__toolbar",class:_vm.icon})]),_c('div',{staticClass:"bg-white/95 text-black w-full py-2.5 pl-2"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }